




























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxScrollView } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import notificationService from '@/services/notificationService';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import { MailConfig } from '@/installationConfig';

import {
  ContactsClient,
  ContactsLookupQuery,
  DataSourceLoadOptionsBase,
  IContactListItemDto,
  MailTemplatesClient,
  MailTemplateType,
  IMailTemplateDto,
  ProjectContactsClient,
  IMailProgressStatementCommand,
  ProgressStatementsClient,
  MailProgressStatementCommand,
  ProgressStatementExportType,
  ProgressStatementDto,
} from '@/data/web-api-client';

import { DxForm, DxSimpleItem, DxRequiredRule, DxEmailRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import { DxHtmlEditor } from 'devextreme-vue/html-editor';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxScrollView,
    DxRequiredRule,
    DxEmailRule,
    DxHtmlEditor,
  },
})
export default class MailPopup extends Vue {
  @Prop({ required: true })
  progressStatement!: ProgressStatementDto;

  @Prop({ required: true })
  exportType!: ProgressStatementExportType;

  show: boolean = false;
  sending: boolean = false;
  fullscreen: boolean = false;
  formdata: IMailProgressStatementCommand | any = {
    template: '',
    from: '',
    to: [],
    cc: [],
    subject: '',
    content: '',
    documentNumber: '',
  };
  templates: IMailTemplateDto[] = [];

  public async open() {
    this.formdata.to.splice(0, this.formdata.to.length);
    this.formdata.cc.splice(0, this.formdata.cc.length);
    this.loadProjectContacts();

    if (this.progressStatement.contact && this.progressStatement.contact.email && this.progressStatement.contact.email !== '') {
      (this.formdata.to as string[]).push(this.progressStatement.contact.email);
    } else if (this.progressStatement.customer && this.progressStatement.customer.email && this.progressStatement.customer.email !== '') {
      (this.formdata.to as string[]).push(this.progressStatement.customer.email);
    }

    this.formdata.documentNumber = this.mergedDocumentNumber;

    const lastUsedEmail = localStorage.getItem('progressStatement_last_used_email');
    const lastUsedTemplate = localStorage.getItem('progressStatement_last_used_template');
    if (lastUsedEmail) {
      this.formdata.from = lastUsedEmail;
    } else {
      this.formdata.from = this.currentUser.username;
    }

    if (lastUsedTemplate) {
      this.formdata.template = lastUsedTemplate;
      const template = this.templates.find((o) => o.name === lastUsedTemplate);
      if (template) {
        this.formdata.subject = template.subject ? template.subject : '';
        this.formdata.content = template.content ? template.content : '';
        this.replaceTags();
      }
    }

    this.show = true;
  }

  async send() {
    try {
      if (this.formdata.from) {
        localStorage.setItem('progressStatement_last_used_email', this.formdata.from);
        localStorage.setItem('progressStatement_last_used_template', this.formdata.template);
      }

      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (!validationResult.isValid) {
        notificationService.invalidForm();
        return;
      }

      this.sending = true;
      // TO KEEP MAIL FORMAT CORRECT, REPLACE P-TAG WITH DIV-TAG
      this.formdata.content = this.formdata.content.replaceAll('<p>', '<div>').replaceAll('</p>', '</div>');
      this.formdata.exportType = this.exportType;
      await new ProgressStatementsClient(undefined, this.$axios).mail(new MailProgressStatementCommand(this.formdata));
      notificationService.showSuccessMessage('Mail verstuurd');
      this.$emit('mailSend');
      this.show = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.sending = false;
    }
  }

  async loadProjectContacts() {
    if (!this.progressStatement.projectId || this.progressStatement.projectId === '') {
      return;
    }

    const res = await new ProjectContactsClient(undefined, this.$axios).getContacts(this.progressStatement.projectId);
    res.forEach((contact) => {
      if (contact.sendProgressStatement && contact.contact && contact.contact.email && contact.contact.email !== '') {
        if (this.formdata.to.indexOf(contact.contact.email) === -1) {
          this.formdata.to.push(contact.contact.email);
        }
      }
    });
  }

  async created() {
    try {
      this.templates = await new MailTemplatesClient(undefined, this.$axios).getAll(MailTemplateType.ProgressStatement);
    } catch {
      // do nothing
    }
  }

  replaceTags() {
    const self = this;
    try {
      let contact = null;
      if (this.progressStatement) {
        if (this.progressStatement.contact) {
          contact = this.progressStatement.contact;
        } else if (this.progressStatement.customer) {
          contact = this.progressStatement.customer;
        }
      }

      while (this.formdata.content.indexOf('#Name') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Name', contact ? contact.displayName : '');
      }

      while ((this.formdata.content as string).indexOf('#DocumentNumber') !== -1) {
        this.formdata.content = this.formdata.content.replace('#DocumentNumber', this.mergedDocumentNumber);
      }

      if (contact && contact.type === 'Contact') {
        const splittedName = contact.displayName ? contact.displayName.split(' ') : null;
        if (splittedName && splittedName.length > 0) {
          const firstname = splittedName[0];
          const lastname = contact.displayName!.replace(firstname, '');

          while (this.formdata.content.indexOf('#Contact_Firstname') !== -1) {
            this.formdata.content = this.formdata.content.replace('#Contact_Firstname', firstname);
          }

          while (this.formdata.content.indexOf('#Contact_Lastname') !== -1) {
            this.formdata.content = this.formdata.content.replace('#Contact_Lastname', lastname);
          }
        }
      }

      while (this.formdata.content.indexOf('#Contact_Firstname') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Contact_Firstname', '');
      }

      while (this.formdata.content.indexOf('#Contact_Lastname') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Contact_Lastname', '');
      }
      while (this.formdata.content.indexOf('#Project_Name') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Project_Name', this.progressStatement.projectName);
      }

      while (this.formdata.subject.indexOf('#Project_DocumentNumber') !== -1) {
        this.formdata.subject = this.formdata.subject.replace('#Project_DocumentNumber', this.progressStatement.projectNumber);
      }

      while (this.formdata.subject.indexOf('#Project_Name') !== -1) {
        this.formdata.subject = this.formdata.subject.replace('#Project_Name', this.progressStatement.projectName);
      }

      while (this.formdata.content.indexOf('#Project_DocumentNumber') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Project_DocumentNumber', this.progressStatement.projectNumber);
      }

      while (this.formdata.subject.indexOf('#Period') !== -1) {
        if (!this.progressStatement.periodFrom && !this.progressStatement.periodUntil) {
          this.formdata.subject = this.formdata.subject.replace('#Period', 'Periode onbekend');

          continue;
        }

        const periodFrom = this.progressStatement.periodFrom ? this.progressStatement.periodFrom?.toLocaleDateString() : '';
        const periodUntil = this.progressStatement.periodUntil ? this.progressStatement.periodUntil?.toLocaleDateString() : '';

        const periodString = `${periodFrom} - ${periodUntil}`;

        this.formdata.subject = this.formdata.subject.replace('#Period', periodString);
      }

      while (this.formdata.content.indexOf('#Period') !== -1) {
        if (!this.progressStatement.periodFrom && !this.progressStatement.periodUntil) {
          this.formdata.content = this.formdata.content.replace('#Period', 'Periode onbekend');

          continue;
        }

        const periodFrom = this.progressStatement.periodFrom ? this.progressStatement.periodFrom?.toLocaleDateString() : '';
        const periodUntil = this.progressStatement.periodUntil ? this.progressStatement.periodUntil?.toLocaleDateString() : '';

        const periodString = `${periodFrom} - ${periodUntil}`;

        this.formdata.content = this.formdata.content.replace('#Period', periodString);
      }
    } catch {
      // do nothing
    }
  }

  get currentUser() {
    return this.$store.getters.currentUser;
  }

  get htmlEditorOptions() {
    return {
      toolbar: {
        items: [
          'bold',
          'italic',
          'underline',
          'separator',
          'alignLeft',
          'alignCenter',
          'alignRight',
          'alignJustify',
          'separator',
          'orderedList',
          'bulletList',
          'separator',
          'link',
          'separator',
          {
            formatName: 'size',
            formatValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
          },
          {
            formatName: 'header',
            formatValues: [false, 1, 2, 3, 4, 5],
          },
        ],
      },
    };
  }

  get contactDataSource() {
    const client = new ContactsClient(undefined, this.$axios);
    return new DataSource({
      store: new dxCustomStore({
        key: 'id',
        load: async (loadOptions) => {
          if (loadOptions.filter) {
            loadOptions.filter = undefined;
          }
          if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
            loadOptions.filter = [['displayName', loadOptions.searchOperation, loadOptions.searchValue], 'or', ['email', loadOptions.searchOperation, loadOptions.searchValue]];
          }

          const res = await client.lookupContacts(
            new ContactsLookupQuery({
              projectId: this.progressStatement.projectId,
              options: new DataSourceLoadOptionsBase(
                Object.assign({}, loadOptions, {
                  stringToLower: true,
                })
              ),
            })
          );

          return res;
        },
        byKey: async (val: string) => {
          return await client.getBasicInfo(val);
        },
      }),
      paginate: this.progressStatement.projectId ? false : true,
    });
  }

  get mergedDocumentNumber() {
    return `${this.progressStatement.documentNumber}-${this.progressStatement.versionNumber}`;
  }

  get contactOptions() {
    const self = this;
    return {
      dataSource: this.contactDataSource,
      searchEnabled: true,
      remoteOperations: true,
      searchExpr: ['email', 'displayName'],
      acceptCustomValue: true,
      valueExpr: (item: any) => {
        if (!item) {
          return 'undefined';
        }

        if (typeof item === 'string') {
          return item;
        }

        return item.email;
      },
      displayExpr: (val: IContactListItemDto | string) => {
        if (!val) {
          return '';
        }

        if (typeof val === 'string') {
          return val;
        }

        if (!val.displayName) {
          return val.email;
        }
        return `${val.displayName} <${val.email}>`;
      },
      onCustomItemCreating: (args: any) => {
        args.customItem = args.text;
      },
    };
  }

  get fromOptions() {
    const self = this;
    return {
      dataSource: [
        MailConfig.infoMailAddress,
        MailConfig.accountingMailAddress,
        MailConfig.executionMailAddress,
        MailConfig.invoicingMailAddress,
        MailConfig.calculationMailAddress,
        this.currentUser.username,
      ],
    };
  }

  get templateOptions() {
    const self = this;
    return {
      dataSource: this.templates,
      valueExpr: 'name',
      displayExpr: 'name',
      onItemClick: (e: any) => {
        self.formdata.subject = e.itemData.subject;
        self.formdata.content = e.itemData.content;
        self.formdata.language = e.itemData.language;

        self.replaceTags();
      },
    };
  }
}
